// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3hpdW","calendarButtons":"ClockData_calendarButtons__2uBYD"};